const icon = require('vue-svgicon');
icon.register({
    'recipe-cyl': {
        width: 41,
        height: 41,
        viewBox: '0 0 41 41',
        data: `<path pid="0" d="M1 17.36V4.85M39.44 4.85c0 2.13-8.6 3.86-19.22 3.86S1 6.98 1 4.85 9.61 1 20.22 1s19.22 1.73 19.22 3.85zM1.01 17.1c0 2.13 8.6 3.86 19.22 3.86s19.22-1.73 19.22-3.86M39.44 17.36V4.85M1.01 34.94V22.43" _stroke="#010101" stroke-width="1.2"/><path pid="1" d="M35.33 19.49c2.58.81 4.11 1.83 4.11 2.93 0 2.64-8.6 4.77-19.22 4.77S1.01 25.06 1.01 22.42c0-1.1 1.54-2.12 4.11-2.93M1.01 34.94c0 2.63 8.6 4.77 19.22 4.77s19.22-2.13 19.22-4.77M39.44 34.94V22.43" _stroke="#010101" stroke-width="1.2"/>`,
    },
});
